<template>
  <div class="dealers-list">
    <top-bar
      title="Periodos"
      :show-add-button="true"
      add-button-label="Añadir Periodo"
      @addItem="$router.push({name: 'periods-create'})"
    />
    <scrollable-container>
      <div class="padding-20">
        <ms-grid
          :data="items"
          :columns="columns"
          :options="options"
          :pager="pager"
        />
      </div>
    </scrollable-container>
    <router-view/>
  </div>
</template>

<script>
import DefaultGuards from '@/guards/default.guards'
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import MsGrid from '@/modules/grid/ms-grid'
import StarRating from '@/components/star-rating.vue'
import { mapGetters } from 'vuex'
import DefaultActions from '@/helpers/default-actions'

export default {
  name: 'PeriodList',
  components: {
    TopBar,
    ScrollableContainer,
    StarRating,
    MsGrid
  },
  data () {
    return {
      columns: [
        {
          label: 'ID',
          property: 'id',
          align: 'center'
        },
        {
          label: 'Nombre',
          property: 'name'
        },
        {
          label: 'Fecha de inicio',
          property: 'startDate',
          type: 'date'
        },
        {
          label: 'Fecha de fin',
          property: 'endDate',
          type: 'date'
        }
      ],
      options: {
        selectable: false,
        actions: [DefaultActions.edit('periods')]
      }
    }
  },
  computed: {
    ...mapGetters('periods', {
      items: 'items',
      pager: 'pagination'
    })
  },
  methods: {
    randomStar () {
      return Math.ceil(Math.random() * 5)
    }
  },
  beforeRouteUpdate: DefaultGuards.onQuery('periods', {}, ['name']),
  beforeRouteEnter: DefaultGuards.onQuery('periods', {}, ['name'])
}
</script>

<style scoped>
.dealer-list {
  max-height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/app/periods/periods-list-view.vue